export default __webpack_public_path__ + "static/steve-63c2942a5d192dc095e1e69f1048cdd4.jpg";